import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { ARKIK_DIALOG_DATA } from '../arkik-dialog/arkik-dialog.service';
import { ArkikDialogRef } from '../arkik-dialog/arkik-dialog-ref';

@Component({
  selector: 'app-pwa-install-instructions',
  template: `
    <section
      role="dialog"
      aria-modal="true"
      aria-labelledby="pwa-install-title"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
    >
      <arkik-ios-pwa-prompt [safari]="data.safari" (dismiss)="close()"></arkik-ios-pwa-prompt>
    </section>
  `,
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .pwa-install-dialog .arkik-dialog-container {
        height: auto;
        max-height: calc(100vh - 32px);
        max-height: calc(100dvh - 32px);
        padding: 56px 24px 24px;
        overflow: hidden;
      }

      .pwa-install-dialog .dialog-close-btn {
        top: 16px;
        right: 16px;
        z-index: 1;
      }

      .pwa-install-dialog app-pwa-install-instructions section {
        overflow-wrap: anywhere;
      }
    `,
  ],
})
export class PwaInstallInstructionsComponent {
  constructor(
    @Inject(ARKIK_DIALOG_DATA) public data: { safari: boolean },
    private dialogRef: ArkikDialogRef<PwaInstallInstructionsComponent, void>,
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
